export default "__VITE_ASSET__c974f16b__"